import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import _, { cloneDeep as _cloneDeep } from 'lodash';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { confirmAlert } from 'react-confirm-alert';
import Breadcrumb from '../Breadcrumb';
import {
  getTrashCampaignsAndEditions,
  restoreCampaignR,
  setVariablesTrash,
  restoreEditionR,
  getTrashMedia,
  getTrashMediaOfParent,
  deleteFile,
  deleteFolder,
  restoreFolderR,
  restoreFileR,
  getTrashEditions,
  deleteAllR,
  deleteEditionR,
} from '../../../actions/TrashActions';

import SimplePrompt from '../SimplePrompt';
import Loader from '../Loader';
import EditionPreviews from '../campaigns/EditionPreviews';
import { getPDFR, setVariables } from '../../../actions/CampaignActions';
import { S3_LINKS_DIV } from 'js/constants';

class Trash extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSettings: false,
      modalData: null,
      deleting: false,
      action: 'new',
      cCampaigns: [],
      cEditions: [],
      cFolders: [],
      cMedia: [],
      dFolders: [],
      dMedia: [],
      openedFolder: undefined,
      parentDirName: '',
      storeF: [],
      storeC: [],
      openedCampaign: undefined,
    };
  }

  componentDidMount = () => {
    this.props.getTrashCampaignsAndEditions('dummy');
    this.props.getTrashMedia();
  };

  componentDidUpdate = prevProps => {
    if (this.props.restore === true) {
      this.ShowCampaigns();
      this.ShowEditions();
      this.ShowFolders();
      this.ShowMedia();
      this.props.setVariablesTrash('restorefalse');
    }

    if (prevProps.errorMessage !== this.props.errorMessage) {
      const options = {
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert-body">
              <h1>Es ist ein Fehler augetreten</h1>
              <p>{this.props.errorMessage}</p>
              <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                <Button
                  style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                  bsStyle="primary"
                  onClick={onClose}
                >
                  OK
                </Button>
              </div>
            </div>
          );
        },
        childrenElement: () => <div />,
        closeOnEscape: true,
        closeOnClickOutside: true,
      };
      confirmAlert(options);
    }

    if (
      prevProps.deletedCampaigns !== this.props.deletedCampaigns ||
      (prevProps.deleterPendingC !== this.props.deleterPendingC && this.props.deleterPendingC === false)
    ) {
      this.ShowCampaigns();
    }
    if (prevProps.deletedEditions !== this.props.deletedEditions) {
      this.ShowEditions();
    }

    if (this.props.pending !== prevProps.pending && this.props.pending === false) {
      this.ShowEditions();
    }

    if (prevProps.deletedFolders !== this.props.deletedFolders) {
      this.ShowFolders();
    }

    if (prevProps.deletedImages !== this.props.deletedImages) {
      this.ShowMedia();
    }

    if (this.props.pendingMediaLibrary !== prevProps.pendingMediaLibrary && this.props.pendingMediaLibrary === false) {
      this.ShowFolders();
      this.ShowMedia();
    }
  };

  getPDF = (type, editionId) => {
    const {
      intl: { messages },
    } = this.props;
    // set previewing to editionID
    this.props.setVariables(editionId);
    let api = 'previewcopies';
    if (type === 'print') {
      api = 'mastercopies';
    } else if (type === 'image') {
      api = 'images/mastercopies';
    }
    const { getPDFR } = this.props;
    getPDFR(api, editionId, messages);
  };

  webPreview = () => {
    const { edition } = this.props;
    const preview = window.open(
      window.location.protocol + '//' + window.location.hostname + '/de/website/' + edition.id,
      '_blank'
    );
    preview.focus();
  };

  removeTrash = () => {
    this.props.deleteAllR();
  };

  removeCampaign = (e, campaignId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteCampaign(campaignId, 'trash');
    this.props.setVariablesTrash('c_delete', campaignId);
  };

  restoreCampaign = campaignId => {
    this.props.restoreCampaignR(campaignId);
  };

  removeFolder = (e, fileId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteFolder(fileId);
    // this.props.setVariablesTrash(fileId)
  };

  restoreFolder = folderId => {
    this.props.restoreFolderR(folderId);
  };

  removeMedia = (e, fileId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteFile(fileId);
    // this.props.setVariablesTrash("c_delete", campaignId)
  };

  restoreMedia = fileId => {
    this.props.restoreFileR(fileId);
  };

  removeEdition = (e, editionId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteEditionR(editionId, 'trash');
    this.props.setVariablesTrash('e_delete', editionId);
  };

  restoreEdition = (editionId, campaignId) => {
    this.props.restoreEditionR(editionId, campaignId);
  };

  ShowCampaigns = () => {
    const { deletedCampaigns, pendingRestoreC, deleterPendingC } = this.props;
    let campaignsss;
    if (deletedCampaigns) {
      campaignsss = deletedCampaigns.map(dCampaigns => {
        if (
          dCampaigns.is_in_trash === true ||
          (dCampaigns.is_in_trash === false && dCampaigns.shadow_campaign === true)
        ) {
          return (
            <div className="deletedCampaigns" key={dCampaigns.id}>
              {pendingRestoreC || deleterPendingC ? (
                <div className="TitleAndLoader">
                  <Loader />
                </div>
              ) : (
                <></>
              )}
              <div
                className="dCContent"
                onClick={() => {
                  this.openCampaign(dCampaigns.id);
                }}
              >
                {dCampaigns.shadow_campaign === true ? (
                  <h5>
                    {dCampaigns.title} <i className="fad fa-eclipse-alt" />
                  </h5>
                ) : (
                  <h5>{dCampaigns.title}</h5>
                )}
                <p>
                  {dCampaigns.creator.profile.first_name +
                    ' ' +
                    dCampaigns.creator.profile.last_name +
                    ' ' +
                    dCampaigns.creator.profile.email}
                </p>
              </div>

              {dCampaigns.shadow_campaign !== true ? (
                <SimplePrompt
                  disabled=""
                  onSuccess={e => {
                    this.removeCampaign(e, dCampaigns.id);
                  }}
                />
              ) : (
                <></>
              )}
              <Button
                className="buttonRestore"
                style={{ margin: '0 auto', width: 'max-content' }}
                onClick={() => this.restoreCampaign(dCampaigns.id)}
              >
                <i className="far fa-trash-restore" />
                <span className="restoreText">{this.props.intl.messages.restore}</span>
              </Button>
            </div>
          );
        }
        return <></>;
      });
    }
    this.setState({ cCampaigns: campaignsss });
  };

  ShowEditions = option => {
    const { deletedEditions, pendingRestoreE, deleterPendingE, parentIsMain2, previewingR } = this.props;
    const { openedCampaign } = this.state;
    let editionsss;
    const initialPreview = S3_LINKS_DIV.TEMPLATE_INITIAL_PREVIEW;
    let filter;
    let disablePreview = '';

    if (previewingR !== false) {
      disablePreview = 'disabled';
    }

    if (deletedEditions) {
      editionsss = deletedEditions.map(dEditions => {
        const lastEdit = new Date(dEditions.mdate);
        const created = new Date(dEditions.cdate);
        const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: 'numeric' };

        if (option === undefined || option === '' || option === 'store') {
          if (parentIsMain2 === true) {
            // root
            filter = true;
          } else {
            // unterverzeichnis
            filter = dEditions.campaign.id === openedCampaign;
          }
        } else {
          // back
          filter = dEditions.where_in_trash === 'main';
        }

        if (dEditions.in_trash === true && filter) {
          return (
            <div className="deletedEditions" key={dEditions.id}>
              {pendingRestoreE || deleterPendingE ? (
                <div className="TitleAndLoader">
                  <Loader />
                </div>
              ) : (
                <></>
              )}
              <header>
                <div className="header-left">
                  <Dropdown id={'settings-' + dEditions.id}>
                    <Dropdown.Toggle noCaret className="bg-red">
                      <i className="fas fa-bars" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <MenuItem onClick={() => this.restoreEdition(dEditions.id, dEditions.campaign.id)}>
                        {this.props.intl.messages.restore}
                      </MenuItem>
                      <MenuItem href="#">
                        <SimplePrompt
                          iconClass="no-icon"
                          onSuccess={e => {
                            this.removeEdition(e, dEditions.id);
                          }}
                        />
                      </MenuItem>
                      {dEditions.template && dEditions.template.export_type.value === '000000000000000000000001' ? (
                        <MenuItem disabled={disablePreview} onClick={() => this.getPDF('image', dEditions.id)}>
                          {'Bild exportieren '}{' '}
                          {previewingR === dEditions.id && <i className="fa fa-spin fa-spinner-third" />}
                        </MenuItem>
                      ) : dEditions.template && dEditions.template.export_type.value === '000000000000000000000003' ? (
                        <MenuItem disabled={disablePreview} onClick={() => this.webPreview()}>
                          {this.props.intl.messages.campaign.edition_preview}{' '}
                          {previewingR === dEditions.id && <i className="fa fa-spin fa-spinner-third" />}
                        </MenuItem>
                      ) : (
                        <MenuItem disabled={disablePreview} onClick={() => this.getPDF('preview', dEditions.id)}>
                          {this.props.intl.messages.campaign.edition_preview}{' '}
                          {previewingR === dEditions.id && <i className="fa fa-spin fa-spinner-third" />}
                        </MenuItem>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="header-fill">
                  <h5>{dEditions?.template?.title}</h5>
                </div>
              </header>
              <div className="dEDetails">
                <div className="dEContent">
                  <div className="row">
                    <div className="col-md-7 p-l-0">
                      <p>
                        <span>{this.props.intl.messages.campaign.edition_title + ':'}</span>
                        <span className="edition_title">{dEditions.title}</span>
                      </p>
                      <p>
                        <span>{this.props.intl.messages.campaign.created_by}</span>
                        <span className="edition_title">
                          {dEditions.creator
                            ? dEditions.creator.profile.first_name + ' ' + dEditions.creator.profile.last_name
                            : 'unbekannt'}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-5 p-r-0 text-right">
                      <p>
                        <span>{this.props.intl.messages.campaign.last_edited}</span>
                        <span className="w110">{lastEdit.toLocaleDateString('de-DE', options)}</span>
                      </p>
                      <p>
                        <span>{this.props.intl.messages.campaign.generated}</span>
                        <span className="w110">{created.toLocaleDateString('de-DE', options)}</span>
                      </p>
                    </div>
                  </div>

                  <div className="deletedEPreviews">
                    <EditionPreviews key={'previews_' + dEditions.id} editionPreviews={dEditions.previews} />
                  </div>
                </div>
              </div>

              <footer>
                <div className="footer-left" />
                <div className="footer-right">
                  <SimplePrompt
                    disabled=""
                    onSuccess={e => {
                      this.removeEdition(e, dEditions.id);
                    }}
                  />
                  <Button bsStyle="success" onClick={() => this.restoreEdition(dEditions.id, dEditions.campaign.id)}>
                    <i className="far fa-trash-restore" />
                    <span className="restoreText"> {this.props.intl.messages.restore}</span>
                  </Button>
                </div>
              </footer>
            </div>
          );
        }
        return <></>;
      });
    }
    if (option === 'back') {
      this.setState({ cEditions: editionsss, openedCampaign: 'main' });
    } else {
      this.setState({ cEditions: editionsss });
    }
  };

  ShowFolders = option => {
    const { deletedFolders, parentIsMain, pendingFolderAction } = this.props;
    const { openedFolder } = this.state;
    let folders;
    let filter;
    let parentDir;

    if (option === 'back') {
      const index = _.findIndex(deletedFolders, folder => folder.id === openedFolder);
      parentDir = deletedFolders[index].parent;
      if (deletedFolders[index].where_in_trash !== undefined && deletedFolders[index].where_in_trash === 'main') {
        parentDir = 'main';
      }

      if (parentDir !== 'main') {
        const index2 = _.findIndex(deletedFolders, folder => folder.id === parentDir);
        this.setState({ parentDirName: deletedFolders[index2].name });
        this.ShowMedia('back', parentDir, openedFolder);
      } else {
        this.setState({ parentDirName: 'Root' });
        this.ShowMedia('back', 'main', openedFolder);
      }
    }

    if (option === 'store') {
      this.ShowMedia();
    }

    if (deletedFolders) {
      folders = deletedFolders.map(dFolder => {
        if (option === undefined || option === '' || option === 'store') {
          if (parentIsMain === true) {
            // root
            filter = true;
          } else {
            // unterverzeichnis
            filter = dFolder.parent === openedFolder;
          }
        } else if (parentDir !== 'main') {
          filter = dFolder.parent === parentDir;
        } else {
          filter = dFolder.where_in_trash === 'main';
        }

        if (
          (dFolder.is_in_trash === true || (dFolder.is_in_trash === false && dFolder.shadow_folder === true)) &&
          filter
        ) {
          return (
            <div className="deletedFolders" key={dFolder.id}>
              {pendingFolderAction ? (
                <div className="TitleAndLoader">
                  <Loader />
                </div>
              ) : (
                <></>
              )}
              <div
                className="dFImage"
                onClick={() => {
                  this.openFolder(dFolder.id);
                }}
              >
                <img
                  src="https://creacheck-icons.s3.eu-central-1.amazonaws.com/folder-solid-cutted-svg-weiss.svg"
                  alt={dFolder.name}
                />
              </div>
              <div className="dFContent">
                {dFolder.shadow_folder === true ? (
                  <h5>
                    {dFolder.name} <i className="fad fa-eclipse-alt" />
                  </h5>
                ) : (
                  <h5>{dFolder.name}</h5>
                )}
              </div>

              <div className="buttons">
                {dFolder.shadow_folder !== true ? (
                  <SimplePrompt
                    disabled=""
                    onSuccess={e => {
                      this.removeFolder(e, dFolder.id);
                    }}
                  />
                ) : (
                  <></>
                )}
                <Button style={{ margin: '0 auto' }} bsStyle="success" onClick={() => this.restoreFolder(dFolder.id)}>
                  <i className="far fa-trash-restore" />
                  <span className="restoreText"> Wiederherstellen</span>
                </Button>
              </div>
            </div>
          );
        }
        return <></>;
      });
    }
    this.setState({ cFolders: folders });
  };

  openCampaign = campaignId => {
    const { storeC } = this.state;
    const { getTrashEditions } = this.props;
    const index = _.findIndex(storeC, store => store === campaignId);
    this.setState({ openedCampaign: campaignId }, () => {
      if (index > -1) {
        this.ShowEditions('store');
      } else {
        const addCampaignsToStore = _cloneDeep(storeC);
        addCampaignsToStore.push(campaignId);
        this.setState({ storeC: addCampaignsToStore });
        getTrashEditions(campaignId);
      }
    });
  };

  openFolder = folderId => {
    const { storeF } = this.state;
    const { getTrashMediaOfParent } = this.props;
    const index = _.findIndex(storeF, store => store === folderId);
    this.setState({ openedFolder: folderId }, () => {
      if (index > -1) {
        this.ShowFolders('store');
      } else {
        const addFoldersToStore = _cloneDeep(storeF);
        addFoldersToStore.push(folderId);
        this.setState({ storeF: addFoldersToStore });
        getTrashMediaOfParent(folderId);
      }
    });
  };

  ShowMedia = (option, parentDir) => {
    const { deletedImages, parentIsMain, pendingMediaAction } = this.props;
    const { openedFolder } = this.state;
    let media;
    let filter;

    if (deletedImages && deletedImages.length > 0) {
      media = deletedImages.map(dMedia => {
        if (option === undefined || option === '') {
          if (parentIsMain === true) {
            // root
            filter = true;
          } else {
            // unterverzeichnis
            filter = dMedia.parent === openedFolder;
          }
        } else if (parentDir !== 'main') {
          filter = dMedia.parent === parentDir;
        } else {
          filter = dMedia.where_in_trash === 'main';
        }

        if (dMedia.is_in_trash === true && filter) {
          const s3urlThumb = S3_LINKS.MEDIA_IMGS_THUMB;
          const s3urlOriginal = S3_LINKS.MEDIA_IMGS_ORIGINAL;
          return (
            <div className="deletedMedia" key={dMedia.id}>
              {pendingMediaAction ? (
                <div className="TitleAndLoader">
                  <Loader />
                </div>
              ) : (
                <></>
              )}
              <div className="deletedMediaImage">
                {dMedia.thumb === 'video/mp4' ? (
                  <video controls style={{ width: '100%', height: '100%' }}>
                    <source src={s3urlOriginal + dMedia.fileKey} type="video/mp4" />
                  </video>
                ) : (
                  <img src={s3urlThumb + dMedia.thumb} alt={dMedia.filename} />
                )}
              </div>
              <div className="dMContent">
                <h5>{dMedia.title ? dMedia.title : dMedia.filename}</h5>
              </div>

              <div className="buttons">
                <SimplePrompt
                  disabled=""
                  onSuccess={e => {
                    this.removeMedia(e, dMedia.id);
                  }}
                />
                <Button style={{ margin: '0 auto' }} bsStyle="success" onClick={() => this.restoreMedia(dMedia.id)}>
                  <i className="far fa-trash-restore" />
                  <span className="restoreText"> Wiederherstellen</span>
                </Button>
              </div>
            </div>
          );
        }
        return <></>;
      });
    }
    if (option === 'back') {
      this.setState({ cImages: media, dMedia: deletedImages, openedFolder: parentDir });
    } else {
      this.setState({ cImages: media, dMedia: deletedImages });
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      deletedCampaigns,
      deletedFolders,
    } = this.props;
    const { cCampaigns, cEditions, cFolders, cImages, openedFolder, openedCampaign } = this.state;

    let openedFolderName = messages.root;
    if (openedFolder) {
      const index = _.findIndex(deletedFolders, folder => folder.id === openedFolder);
      if (index > -1) {
        openedFolderName = deletedFolders[index].name;
      }
    }

    let openedCampaignName = messages.root;
    if (openedCampaign) {
      const index = _.findIndex(deletedCampaigns, campaign => campaign.id === openedCampaign);
      if (index > -1) {
        openedCampaignName = deletedCampaigns[index].title;
      }
    }

    return (
      <div className="padding-25 sm-padding-10">
        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: appIntl.urlPrefix + 'account/trash', name: 'Papierkorb' },
          ]}
          className="p-t-0"
        />
        <h1>{messages.trash_bin}</h1>
        <div className="deleteTrashBin">
          <SimplePrompt
            disabled=""
            buttonLabel={messages.delete_trash_bin}
            onSuccess={() => {
              this.removeTrash();
            }}
          />
        </div>
        {this.state.openedFolder && this.state.openedFolder !== 'main' ? (
          <></>
        ) : (
          <>
            <h3>{messages.deleted_campaigns}</h3>
            {this.props.pendingRestoreC ? (
              <span>
                {messages.pls_wait}
                <Loader />
              </span>
            ) : (
              <></>
            )}
            {this.props.deleterPendingC ? (
              <span>
                {messages.pls_wait}
                <Loader />
              </span>
            ) : (
              <></>
            )}
            {this.state.openedCampaign && this.state.openedCampaign !== 'main' ? (
              <Button
                style={{ display: 'block', margin: '20px 20px 20px 0', width: 'max-content' }}
                bsStyle="success"
                onClick={() => this.ShowEditions('back')}
              >
                <span className="restoreText">{messages.go_back}</span>
              </Button>
            ) : (
              <></>
            )}
            <div className="trash">
              {this.props.pending ? (
                <Loader />
              ) : this.state.openedCampaign === 'main' || this.state.openedCampaign === undefined ? (
                cCampaigns
              ) : (
                <></>
              )}
            </div>
            <h3>
              {messages.deleted_editions} {openedCampaignName ? <>in {openedCampaignName} </> : <>in {messages.root}</>}
            </h3>
            {this.props.pendingRestoreE ? (
              <span>
                {messages.pls_wait}
                <Loader />
              </span>
            ) : (
              <></>
            )}
            {this.props.deleterPendingE ? (
              <span>
                {messages.pls_wait}
                <Loader />
              </span>
            ) : (
              <></>
            )}
            <div className="trash">{this.props.pending ? <Loader /> : cEditions}</div>
            <div className="extraStyleTrash" />
          </>
        )}
        {this.state.openedCampaign && this.state.openedCampaign !== 'main' ? (
          <></>
        ) : (
          <>
            <h3>
              {messages.deleted_folders} {openedFolderName ? <>in {openedFolderName} </> : <>in {messages.root}</>}
            </h3>
            {this.props.pendingFolderAction ? (
              <span>
                {messages.pls_wait}
                <Loader />
              </span>
            ) : (
              <></>
            )}
            {this.state.openedFolder && this.state.openedFolder !== 'main' ? (
              <Button
                style={{ display: 'block', margin: '20px 20px 20px 0', width: 'max-content' }}
                bsStyle="success"
                onClick={() => this.ShowFolders('back')}
              >
                <span className="restoreText">{messages.go_back}</span>
              </Button>
            ) : (
              <></>
            )}
            <div className="trash">{this.props.pendingMediaLibrary ? <Loader /> : <>{cFolders}</>}</div>
            <h3>
              {messages.deleted_media} {openedFolderName ? <>in {openedFolderName} </> : <>in {messages.root}</>}
            </h3>
            {this.props.pendingMediaAction ? (
              <span>
                {messages.pls_wait}
                <Loader />
              </span>
            ) : (
              <></>
            )}
            <div className="trash">{this.props.pendingMediaLibrary ? <Loader /> : cImages}</div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.campaigns,
    user: state.login.user,
    client: state.selectedClient.company,
    pending: state.trash.pending,
    deletedCampaigns: state.trash.deletedCampaigns,
    restore: state.trash.restore,
    deletedEditions: state.trash.deletedEditions,
    pendingRestoreC: state.trash.pendingRestoreC,
    deleterPendingC: state.deleter.campaign.pending,
    pendingRestoreE: state.trash.pendingRestoreE,
    deleterPendingE: state.trash.pendingDeleteE,
    deletedFolders: state.trash.deletedFolders,
    deletedImages: state.trash.deletedImages,
    pendingMediaLibrary: state.trash.pendingMediaLibrary,
    parentIsMain: state.trash.parentIsMain,
    parentIsMain2: state.trash.parentIsMain2,
    pendingFolderAction: state.trash.pendingFolderAction,
    pendingMediaAction: state.trash.pendingMediaAction,
    errorMessage: state.trash.errorMessage,
    previewingR: state.campaigns.previewingR,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteCampaign: (campaignId, flagOption) => {
      deleterDispatchHelper('campaign', '/api/news/' + campaignId + '/campaigns/' + flagOption + '.json', dispatch);
    },
    deleteEditionR: (editionId, flagOption) => {
      dispatch(deleteEditionR(editionId, flagOption));
    },
    getTrashCampaignsAndEditions: data => {
      dispatch(getTrashCampaignsAndEditions(data));
    },
    getTrashEditions: data => {
      dispatch(getTrashEditions(data));
    },
    restoreCampaignR: campaignId => {
      dispatch(restoreCampaignR(campaignId));
    },
    setVariablesTrash: (varTrash, id) => {
      dispatch(setVariablesTrash(varTrash, id));
    },
    restoreEditionR: (editionId, campaignId) => {
      dispatch(restoreEditionR(editionId, campaignId));
    },
    getTrashMedia: data => {
      dispatch(getTrashMedia(data));
    },
    getTrashMediaOfParent: data => {
      dispatch(getTrashMediaOfParent(data));
    },
    deleteFile: data => {
      dispatch(deleteFile(data));
    },
    deleteFolder: data => {
      dispatch(deleteFolder(data));
    },
    restoreFolderR: data => {
      dispatch(restoreFolderR(data));
    },
    restoreFileR: data => {
      dispatch(restoreFileR(data));
    },
    deleteAllR: data => {
      dispatch(deleteAllR(data));
    },
    getPDFR: (data, datab, messages) => {
      dispatch(getPDFR(data, datab, messages));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Trash)
  )
);
